import { render } from "./avanteges-vue.vue?vue&type=template&id=4050eff2&scoped=true"
import script from "./avanteges-vue.vue?vue&type=script&lang=js"
export * from "./avanteges-vue.vue?vue&type=script&lang=js"

import "./avanteges-vue.vue?vue&type=style&index=0&id=4050eff2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4050eff2"]])

export default __exports__